import MagazineSection from './magazine-section';

export default MagazineSection;
